<div class="modal-header">
    <h4 class="modal-title">{{ 'Core.UnauthorizedMessage' | translate:locale.language }}</h4>
    <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" (click)="DeletelastVisitedPage()">
    </button>
  </div>
  <div class="modal-body col-sm-12">
    <h6>
      
    </h6>
 
    <hr>

    <div class="form-group">
        <button type="button" class="btn btn-primary mb-2"
            (click)="DeletelastVisitedPage()">OK
        </button>
    </div>
  </div>

  
